import React from 'react';
import {
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  Radio,
  RadioGroup,
  FormControl, CardActions, CardHeader
} from '@mui/material';


export const AccountLogout = (props) => {
  
    const logout = () => {
      const origin = window.location.origin;
      let subdir = process.env.REACT_APP_DIRECTORY;
      let redirect = origin + subdir  + "logout.jsp";
      window.location = redirect;
    }
  
    
      return (
        <>
  
          <form
            autoComplete="off"
            noValidate
          >
            <Card>
              <CardHeader
                title="Logout User"
              />
              
              <CardActions sx={{ m: 1 }}>
                <Button
                  color="primary"
                  variant="contained"
                  disabled={false}
                  onClick={() => logout()}>Logout
                </Button>
              </CardActions>
            </Card>
          </form >
        </>
      );
    
  };